// extracted by mini-css-extract-plugin
export default {"change_email__wrapper":"styles_change_email__wrapper__s7lgH"};